import http from '@core/fetch'

export default {
  // 父商家套餐排序-保留排序
  sendMainWorkSort: body =>
    http.post('/p/wedding/index.php/MainAdmin/APISetMeal/workSort', {
      body
    }),
  // 套餐排序-保留排序
  sendWorkSort: body =>
    http.post('/p/wedding/index.php/admin/APISetMeal/workSort', {
      body
    }),
  // 列表页快速设置竖图封面
  editVerticalImage: body =>
    http.post('/p/wedding/index.php/admin/APISetMeal/editVerticalImage', {
      body
    }),
  // 页面顶部相关信息
  getPageHeaderInfo: body =>
    http('/hps/admin/localServerMerchant/work/warnStatusText', {
      body
    }),
  // 获取审核页面tab中的数量
  getTabCount: body =>
    http('/hps/admin/localServerMerchant/work/statusCount', {
      body
    }),
  // 第一次发布记录
  changeRecordRelease: body =>
    http.post('/hps/admin/localServerMerchant/work/recordRelease', {
      body
    }),
  // 草稿箱数量
  getDraftBoxCount: body =>
    http('/hms/merchant/appApi/draftWork/count', {
      body,

      expect: 0
    }),
  // 草稿箱数量
  getDraftBoxList: body =>
    http('/hms/merchant/appApi/draftWork/list', {
      body
    }),
  // 删除草稿箱
  deleteDraftBox: body =>
    http.post('/hms/merchant/appApi/draftWork/delete', {
      body
    })
}
